import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { LogOut, Home, QrCode, Clock, Settings, Layers } from 'lucide-react';

const Layout = ({ session, supabase }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };
  
  const isActive = (path) => location.pathname === path;
  
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <div className="flex items-center">
            <h1 className="text-xl font-bold text-indigo-600">Qr2Air</h1>
          </div>
          <button 
            onClick={handleLogout}
            className="inline-flex items-center text-gray-600 hover:text-gray-900"
          >
            <LogOut className="h-4 w-4 mr-1" />
            <span>Logout</span>
          </button>
        </div>
      </header>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex">
        {/* Sidebar Navigation - Added flex and items-start */}
        <div className="w-64 mr-8">
          <nav className="space-y-1 pt-2">
            <Link
              to="/"
              className={`flex items-center px-3 py-2 text-sm font-medium rounded-md ${
                isActive('/') 
                  ? 'bg-indigo-100 text-indigo-700' 
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <Home className="mr-3 h-5 w-5" />
              Dashboard
            </Link>
            
            <Link
              to="/scenarios"
              className={`flex items-center px-3 py-2 text-sm font-medium rounded-md ${
                location.pathname.includes('/scenarios')
                  ? 'bg-indigo-100 text-indigo-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <QrCode className="mr-3 h-5 w-5" />
              Scenarios
            </Link>

            <Link
              to="/apps"
              className={`flex items-center px-3 py-2 text-sm font-medium rounded-md ${
                location.pathname.includes('/apps')
                  ? 'bg-indigo-100 text-indigo-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <Layers className="mr-3 h-5 w-5" />
              Apps
            </Link>

            <Link
              to="/history"
              className={`flex items-center px-3 py-2 text-sm font-medium rounded-md ${
                isActive('/history')
                  ? 'bg-indigo-100 text-indigo-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <Clock className="mr-3 h-5 w-5" />
              Scan History
            </Link>

            <Link
              to="/account"
              className={`flex items-center px-3 py-2 text-sm font-medium rounded-md ${
                isActive('/account')
                  ? 'bg-indigo-100 text-indigo-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <Settings className="mr-3 h-5 w-5" />
              Account Settings
            </Link>

          </nav>
        </div>
        
        {/* Main Content - Removed padding from original content */}
        <div className="flex-1 pt-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;